import { CustomerService } from "@/services/api/customer.service";

const state = {
  items: [],
};

export default {
  namespaced: true,

  state: { ...state },

  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload;
    },

    ADD_ITEM(state, payload) {
      state.items.unshift(payload);
    },

    REMOVE_ITEM(state, payload) {
      state.items = state.items.filter(item => item.id !== payload.id);
    },
  },

  actions: {
    removeItem({ commit, rootState }, document) {
      return CustomerService.removeDocument(rootState.customer.id, document.id).then(response => {
        if (response.success) {
          commit("REMOVE_ITEM", document);
        }
      });
    },
  },
};
